export const SystemSettingsGetSchema = {
  id: "id",
  pages: {
    general: {
      pageId: "general",
      ddnsName: "ddnsName",
      dnsName: "dnsName",
      defaultDDNSName: "defaultDDNSName",
      ddnsSuffix: "ddnsSuffix",
      reportsServerAddress: "reportsServerAddress",
      cloudGenerateKeyUrl: "cloudGenerateKeyUrl",
      cloudGenerateBackupUploadUrlUrl: "cloudGenerateBackupUploadUrlUrl",
      cloudBackupRestoreServiceUrl: "cloudBackupRestoreServiceUrl",
      cloudStatsServiceUrl: "cloudStatsServiceUrl",
      cloudEventServiceUrl: "cloudEventServiceUrl",
      cloudGatewayProxyServiceUrl: "cloudGatewayProxyServiceUrl",
      cloudLicenseServiceUrl: "cloudLicenseServiceUrl",
      userPassMinLength: "userPassMinLength",
      regKeyLength: "regKeyLength",
      heartbeatInterval: "heartbeatInterval",
      defaultServerGroupName: 'defaultServerGroupName',
      availableServerGroups: 'availableServerGroups'
    },
    overview: {
      pageId: "overview",
      connectedGatewaysNum: "connectedGatewaysNum",
      disconnectedGatewaysNum: "disconnectedGatewaysNum",
      disabledGatewaysNum: "disabledGatewaysNum",
      activePortalsNum: "activePortalsNum",
      disabledPortalsNum: "disabledPortalsNum",
      loggedInUsersNum: "loggedInUsersNum",
    },
    logging: {
      pageId: "logging",
      logLevel: "logLevel",
      logLevelValues: {
        emergency: "EMERGENCY",
        alert: "ALERT",
        critical: "CRITICAL",
        error: "ERROR",
        warning: "WARNING",
        notice: "NOTICE",
        info: "INFO",
        debug: "DEBUG",
      },
      isSyslogClientEnabled: "isSyslogClientEnabled",
      syslogClientHost: "syslogClientHost",
      syslogClientPort: "syslogClientPort",
      isPurgeOldLogs: "isPurgeOldLogs",
      oldLogsDays: "oldLogsDays",
      isOldLogsArchive: "isOldLogsArchive",
    },
    httpProxy: {
      pageId: "httpProxy",
      isProxy: "isProxy",
      proxyHost: "proxyHost",
      proxyPort: "proxyPort",
      proxyUser: "proxyUser",
      proxyPass: "proxyPass",
    },
    mail: {
      pageId: "mail",
      mailHost: "mailHost",
      mailSupport: "mailSupport",
      mailSupportName: "mailSupportName",
      isMailSMTPAuth: "isMailSMTPAuth",
      mailUser: "mailUser",
      mailPassword: "mailPassword",
      mailPort: "mailPort",
      mailRequireTLS: "mailRequireTLS",
    },
    licenseManagement: {
      pageId: "licenseManagement",
      numManagedGWs: "numManagedGWs",
      leftNumLicenses: "leftNumLicenses",
      licensesList: "licensesList",
      licensesListSchema: {
        ip: "ip",
        expirationDate: "expirationDate",
        signature: "signature",
        numberOfGateways: "numberOfGateways",
        featureList: "featureList",
      },
    },
    systemBackup: {
      pageId: "systemBackup",
      isPeriodicBackupSet: "isPeriodicBackupSet",
      summaryReportsUnits: "summaryReportsUnits",
      summaryReportsUnitsValues: {
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
      },
      dayNumber: "dayNumber",
      storageMethod: "storageMethod",
      storageMethodValues: {
        ftpUpload: "FtpUpload",
        networkPath: "NetworkPath",
      },
      ftpServer: "ftpServer",
      ftpPort: "ftpPort",
      ftpPath: "ftpPath",
      ftpUsername: "ftpUsername",
      ftpPassword: "ftpPassword",
      networkPath: "networkPath",
      isUseStaticFileName: "isUseStaticFileName",
      fileName: "fileName",
      isOverwriteFileIfExists: "isOverwriteFileIfExists",
    },
    systemBackupStatus: {
      pageId: "systemBackupStatus",
      isBackupActivated: "isBackupActivated",
      lastRunDate: "lastRunDate",
      state: "state",
      errorDetails: "errorDetails",
      stateValues: {
        idle: "IDLE",
        waiting: "WAITING",
        running: "RUNNING",
        done: "DONE",
        error: "ERROR",
        canceled: "CANCELED",
      },
    },
    certificateAuthority: {
      pageId: "certificateAuthority",
      rootCertExpire: "rootCertExpire",
      autoCertRenew: "autoCertRenew",
      expiresDate: "expiresDate",
      isCaCertificateInitialized: "isCaCertificateInitialized",
      fingerPrint: "fingerPrint",
      gwCertExpire: "gwCertExpire",
      gwCertRenew: "gwCertRenew",
      revocationPeriod: "revocationPeriod",
    },
    notifications: {
      pageId: "notifications",
      systemMonitor: "systemMonitor",
      systemMonitorSchema: {
        isEnabled: "isEnabled",
        data: "data",
        dataSchema: {
          subject: "subject",
          bcc: "bcc",
          body: "body",
          shortBody: "shortBody",
        },
        adminIdList: "adminIdList",
      },
      isReportServers: "isReportServers",
      isReportLicenseExceeded: "isReportLicenseExceeded",
    },
    notificationReports: {
      pageId: "notificationReports",
      shortReport: "shortReport",
      shortReportSchema: {
        reportsUnits: "reportsUnits",
        reportsUnitsValues: {
          daily: "Daily",
          weekly: "Weekly",
          monthly: "Monthly",
        },
        shortPortalReportDayNumber: "shortPortalReportDayNumber",
      },
      extendedReport: "extendedReport",
      extendedReportSchema: {
        reportsUnits: "reportsUnits",
        reportsUnitsValues: {
          daily: "Daily",
          weekly: "Weekly",
          monthly: "Monthly",
        },
        extendedPortalReportDayNumber: "extendedPortalReportDayNumber",
      },
    },
    customAlerts: {
      pageId: "customAlerts",
      alertList: "alertList",
    },
    managementAccessControl: {
      pageId: "managementAccessControl",
      accessMethod: "accessMethod",
      accessMethodValues: {
        any: "Any",
        restricted: "Restricted",
      },
      dataList: "dataList",
      dataListSchema: {
        ipAddr: "ipAddr",
        subnetMask: "subnetMask",
        type: "type",
        domainName: "domainName",
        typeValues: {
          network: "Network",
          ipAddress: "IP Address",
          domain: "Domain name",
        },
      },
    },
    adminAccessControl: {
      pageId: "adminAccessControl",
      accessMethod: "accessMethod",
      accessMethodValues: {
        any: "Any",
        restricted: "Restricted",
      },
      dataList: "dataList",
      dataListSchema: {
        ipAddr: "ipAddr",
        subnetMask: "subnetMask",
        type: "type",
      },
    },
    twoStepAuth: {
      pageId: "twoStepAuth",
      isTwoFactorAuth: "isTwoFactorAuth",
    },
    userPasswordSecurity: {
      pageId: "userPasswordSecurity",
      userPasswordEnforceLength: "userPasswordEnforceLength",
      userPasswordEnforceRenewal: "userPasswordEnforceRenewal",
      userPasswordEnforceRenewalPeriod: "userPasswordEnforceRenewalPeriod",
      userPasswordLengthMin: "userPasswordLengthMin",
      userPasswordLengthMax: "userPasswordLengthMax",
      userPasswordReuseChars: "userPasswordReuseChars",
      userPasswordReuseCharsLength: "userPasswordReuseCharsLength",
      userPasswordDontReuseByNumber: "userPasswordDontReuseByNumber",
      userPasswordDontReuseByNumberVal: "userPasswordDontReuseByNumberVal",
      userPasswordDontReuseByTime: "userPasswordDontReuseByTime",
      userPasswordDontReuseByTimeVal: "userPasswordDontReuseByTimeVal",
      userPasswordNoWhitespaces: "userPasswordNoWhitespaces",
      userPasswordNotUID: "userPasswordNotUID",
      userPasswordRepeatingChars: "userPasswordRepeatingChars",
      userPasswordRepeatingCharsVal: "userPasswordRepeatingCharsVal",
      userPasswordComplexity: "userPasswordComplexity",
      userPasswordComplexityNumRules: "userPasswordComplexityNumRules",
      userPasswordComplexityUppercase: "userPasswordComplexityUppercase",
      userPasswordComplexityLowercase: "userPasswordComplexityLowercase",
      userPasswordComplexityNumbers: "userPasswordComplexityNumbers",
      userPasswordComplexitySpecialChars: "userPasswordComplexitySpecialChars",
    },
  },
};
